export enum UserAvatarStatus {
    CREATE_NEW = "CREATE_NEW",
    USE_EXISTING = "USE_EXISTING"
}